<template>
  <v-container class="mt-10">
    <v-row justify="center" class="mb-10">
      <v-col cols="12" sm="6">
        <div class="text-center display-1">Vos résultats</div>
      </v-col>
    </v-row>
    <v-row v-for="(filiere, i) in filieres" :key="filiere.id">
      <v-col>
        <v-card>
          <v-card-title>{{ percents[i] }}%</v-card-title>
          <v-card-subtitle class="headline">{{ filiere.name }}</v-card-subtitle>
          <v-card-text>{{ filiere.description }}</v-card-text>
          <v-card-actions
            ><v-spacer /><v-btn
              text
              plain
              :ripple="false"
              :href="filiere.link"
              target="_blank"
              >Plus d'informations</v-btn
            ></v-card-actions
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import getPercents from "@/helpers/percents";

export default {
  props: ["filieres", "total"],
  mounted() {
    this.percents = getPercents(
      this.filieres.map((f) => (f.points / this.total) * 100),
      100
    );
  },
  data: () => ({
    percents: [],
  }),
  watch: {
    filieres() {
      this.percents = getPercents(
        this.filieres.map((f) => (f.points / this.total) * 100),
        100
      );
    },
  },
};
</script>